'use strict';
import React from 'react';
import flux from 'utils/flux';
import isEmpty from 'lodash/lang/isEmpty';
import BasketDropdown from 'components/basket/basketDropdown';
import AltContainer from 'alt-container';
import Immutable from 'immutable';

var MediaHeaderSelection = React.createClass({
    displayName: 'MediaHeaderSelection',

    mixins: [
        require('react-onclickoutside')
    ],

    propTypes: {
        media: React.PropTypes.object,
        isFooter: React.PropTypes.bool
    },

    toggleCheck(e) {
        e.preventDefault();
        flux.getActions('media').toggleAllItemSelection();
    },

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        return {
            showAddAll: false
        };
    },

    componentWillReceiveProps( nextProps ) {
        var hasChanged = Immutable.is( nextProps.media, this.props.media ) === false;
        if ( hasChanged ) {
            this.setState({
                showAddAll: false
            });
        }
    },

    handleClickOutside( e ) {
        // if ( this.state.showAddAll ) {
        //     this.setState({
        //         showAddAll: false
        //     });
        // }
    },

    toggleAddAll() {
        this.setState({
            showAddAll: !this.state.showAddAll
        });
    },

    renderAddToFolder() {
        const eligible = this.props.media.filter( item => false !== item.get('showdownload') );
        const selected = eligible.filter( item => true === item.get('_checked') ).toJS();

        if ( this.state.showAddAll && selected.length !== 0 ) {
            return (
                <AltContainer
                    stores={{ basketStore: flux.getStore('basket') }}
                    transform={({ basketStore }) => {
                        var baskets = basketStore.baskets;
                        return { baskets };
                    }}>
                    <BasketDropdown media={selected} isFooter={this.props.isFooter} />
                </AltContainer>
            );
        }
    },

    render() {
        const query    = this.context.router.getCurrentQuery();
        const eligible = this.props.media.filter( item => false !== item.get('showdownload') );
        if ( eligible.size === 0 || isEmpty( query ) ) {
            return false;
        }

        var selected    = eligible.filter( item => true === item.get('_checked') );
        var allSelected = eligible.size === selected.size;

        return (
            <div className="headerbar__selection">
                <div className="selection__all">
                    <form className="all__checkbox">
                        <div className="field__checkbox field__checkbox--small">
                            <input id="check__all" checked={allSelected} type="checkbox" readOnly />
                            <label onClick={this.toggleCheck} htmlFor="check__all">{flux.t('select_all')}</label>
                        </div>
                    </form>
                    <span className="all__count">
                        {flux.getStore('translations').getFormattedMessage('selected_items', {count: selected.size})}
                    </span>
                    <button onClick={this.toggleAddAll} disabled={selected.size === 0} className="btn btn-border all__button">
                        <i className="gopro-download" />
                        {flux.t('add_to_folder')}
                    </button>
                    {this.renderAddToFolder()}
                </div>
            </div>
        );
    }
});

module.exports = MediaHeaderSelection;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerSelection.jsx